// extracted by mini-css-extract-plugin
module.exports = {"toast":"styles_toast__trTiQ","placeHolderShimmer":"styles_placeHolderShimmer__17hto","shimmer":"styles_shimmer__7gY-I"};